import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  coverImage: string;
  publishDate: string;
  duration: string;
  tags: string[];
  rating: number;
  views: number;
  categoryName?: string;
}

export default function ArticleCard({
  title,
  slug,
  excerpt,
  coverImage,
  publishDate,
  duration,
  tags,
  rating,
  views,
  categoryName,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-500/30 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="block overflow-hidden">
        <div className="relative w-full aspect-[4/3] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute top-3 left-3 flex items-center gap-2">
            {categoryName && (
              <span className="px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                {categoryName}
              </span>
            )}
          </div>
          <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-950/70 text-foreground-200 text-xs">
            <i className="ri-time-line"></i>
            {duration}
          </div>
        </div>
      </Link>

      <div className="flex-1 p-4 flex flex-col">
        <Link to={`/article/${slug}`} className="block">
          <h3 className="font-heading text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
            {title}
          </h3>
        </Link>

        <p className="mt-2 text-sm text-foreground-400 line-clamp-2 leading-relaxed flex-1">
          {excerpt}
        </p>

        <div className="mt-3 flex items-center gap-2 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-accent-100/30 text-accent-400 text-xs whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-primary-400 text-xs"></i>
              {rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
          </div>
          <span className="text-xs text-foreground-500">{publishDate}</span>
        </div>
      </div>
    </article>
  );
}